import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CheckCircle2, Lock, MessageSquarePlus } from 'lucide-react';

import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

export default function ConfessionSubmittedPage() {
  const location = useLocation();
  const wasSubmittedThisSession = Boolean(location.state?.fromSubmission);

  return (
    <div className="max-w-3xl mx-auto px-4 py-10" data-testid="confession-submitted-page">
      <Card className="bg-card/90 backdrop-blur-sm border-white/10 shadow-xl">
        <CardHeader className="space-y-4">
          <div className="inline-flex items-center gap-2 rounded-full border border-emerald-500/20 bg-emerald-500/10 px-3 py-1 text-sm text-emerald-700 dark:text-emerald-300">
            <Lock className="w-4 h-4" />
            Submission complete
          </div>
          <div className="space-y-3">
            <CardTitle className="font-serif text-3xl flex items-center gap-3">
              <CheckCircle2 className="w-8 h-8 text-emerald-600 dark:text-emerald-400" />
              Secret submitted successfully
            </CardTitle>
            <CardDescription className="text-base leading-7 text-foreground/80">
              Your confession has been sent. It should be posted within the next day or so. Stay tuned. In the meantime, you can:
            </CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          {!wasSubmittedThisSession && (
            <div className="rounded-xl border border-border/70 bg-muted/30 p-4 text-sm leading-6 text-muted-foreground">
              This is the confirmation page used after a successful native confession submission. If you reached it directly, it is also available as a standalone route for layout review.
            </div>
          )}

          <div className="grid gap-3 sm:grid-cols-2">
            <Button className="btn-primary w-full" asChild data-testid="submit-another-confession-btn">
              <Link to="/submit-confession">
                <MessageSquarePlus className="w-4 h-4 mr-2" />
                Submit Another Confession
              </Link>
            </Button>
            <Button variant="outline" className="w-full" asChild data-testid="return-to-confessions-btn">
              <Link to="/">
                Return to the Confessions
              </Link>
            </Button>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
